module.exports = "/static/img/left.93bbda226eff08c278d51e7841b7836e.jpg";